import { CoinMarketCapTokenData, TokenMarketData } from '@crypto-trading/common/browser';
import { ApiClientManager } from '@/utils/api-client-factory';

/**
 * Token Metadata API functions
 */
export const getTokenMetadata = async (
  symbol: string
): Promise<CoinMarketCapTokenData | null> => {
  const metadata = await ApiClientManager.getTokenMetadataClient().getTokenMetadata(symbol);
  console.log('metadata', metadata);
  return metadata;
};

/** Market cap, FDV, 24h volume, supplies and 24h change (null when unknown). */
export const getTokenMarket = (symbol: string): Promise<TokenMarketData | null> =>
  ApiClientManager.getTokenMetadataClient().getTokenMarket(symbol);

/** First CoinMarketCap tag names of the coin the metadata describes. */
export function metadataTags(metadata: CoinMarketCapTokenData | null | undefined, max = 4): string[] {
  const raw = metadata?.rawResponse?.data;
  const coin = raw ? (Object.values(raw)[0]?.[0] as { "tag-names"?: string[] } | undefined) : undefined;
  return (coin?.["tag-names"] ?? []).slice(0, max);
}
